module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_13.119567e9.jpg";